import axios from "@/api/baseApi";

export default {
  addOrUpdate(form) {
    return axios.post(`/ums/user-settings/v1`, form);
  },
  fetch(id, device) {
    return axios.get(`/ums/user-settings/v1/${id}/${device}`);
  }
}
